import { createAPIMiddlewareLogger } from '../../../modules/logger/createApiMiddlewareLogger';

const logger = createAPIMiddlewareLogger({ name: 'api' });

export const types = {
  SUCCESS: 'API/SUCCESS',
  FAIL: 'API/FAIL',
};

export default function createApiMiddleware({ api }) {
  return ({ getState }) => {
    return (next) => (action) => {
      const { request, result } = action;

      if (!request || result) {
        return next(action);
      }

      const logAndNext = (res, type, requestStart) => {
        if (res.error) {
          logger(res, res.error, new Date() - requestStart);
        }

        next({ ...res, type });
      };

      const requestStart = new Date();

      // WARNING: do not set Promises in one chain, cause problems with store
      const actionPromise = api(request).then((res) => ({
        ...res,
        request,
        state: getState(),
      }));

      actionPromise.then(
        (res) => logAndNext(res, types.SUCCESS, requestStart),
        (res) => logAndNext(res, types.FAIL, requestStart),
      );

      return actionPromise;
    };
  };
}
